<!-- 编辑设备详情弹框 -->
<template>
  <div class="tabList">
    <el-scrollbar style="height: 100%; width: 100%">
      <div class="tabList-container">
        <div class="col">
          <span class="title">{{ $t("cameraList.label.deviceName") }} ：</span
          >{{ devInData.deviceName }}
        </div>
        <div class="col">
          <span class="title">{{ $t("cameraList.label.deviceCode") }} ：</span>
          <div>
            {{ devInData.deviceNumber }}
          </div>
        </div>
        <div class="col">
          <span class="title">{{ $t("cameraList.label.factory") }} ：</span>
          <div>
            {{ devInData.factoryName }}
          </div>
        </div>
        <div class="item">
          <span class="title">设备位置 ：</span
          >{{ devInData.isIndoor == 1 ? "室内" : "室外" }}
        </div>
        <div class="item">
          <span class="title">{{ $t("cameraList.label.area") }} ：</span
          >{{ devInData.areaName }}
        </div>
        <div class="item" v-if="devInData.isIndoor == 0">
          <span class="title">{{ $t("cameraList.label.lat") }} ：</span
          >{{ devInData.latitude }}
        </div>
        <div class="item" v-if="devInData.isIndoor == 0">
          <span class="title">{{ $t("cameraList.label.lng") }} ：</span
          >{{ devInData.longitude }}
        </div>

        <div class="col" v-if="devInData.isIndoor == 1">
          <!-- {{ $t("cameraList.label.buildName") }} -->
          <span class="title">所属楼栋 ：</span>
          <div>
            {{ devInData.buildName }}
          </div>
        </div>
        <div class="item" v-if="devInData.isIndoor == 1">
          <span class="title">楼栋编码 ：</span>{{ devInData.buildingCode }}
        </div>
        <div class="col" v-if="devInData.isIndoor == 1">
          <span class="title">{{ $t("cameraList.label.floorName") }} ：</span>
          <div>
            {{ devInData.floorName }}
          </div>
        </div>
        <div class="item" v-if="devInData.isIndoor == 1">
          <span class="title">{{ $t("cameraList.label.floorCode") }} ：</span
          >{{ devInData.floorId }}
        </div>

        <!-- 表示摄像机 -->
        <div class="item" v-if="$parent.$parent.checkDevType === '18'">
          <span class="title">{{ $t("cameraList.label.deviceType") }} ：</span
          >{{ devInData.deviceTypeName }}
        </div>
        <!-- 表示门禁 -->
        <div v-else class="item">
          <span class="title">{{ $t("cameraList.label.deviceType") }} ：</span
          >{{ devInData.deviceTypeName }}
        </div>
        <!-- <div class="item">
          <span class="title">{{ $t("cameraList.label.buildCode") }} ：</span
          >{{ devInData.buildingId }}
        </div> -->

        <!-- <div class="item" v-if="$parent.$parent.checkDevType === '18'">
          <span class="title">像素宽 ：</span>{{ devInData.resolutionWide }}
        </div>
        <div class="item" v-if="$parent.$parent.checkDevType === '18'">
          <span class="title">像素高 ：</span>{{ devInData.resolutionHigh }}
        </div> -->
        <div class="item">
          <span class="title">{{ $t("cameraList.label.deviceStatus") }} ：</span
          >{{ devInData.statusName }}
        </div>
        <div class="item" v-show="$parent.$parent.checkDevType === '18'">
          <span class="title">{{ $t("cameraList.label.attribute") }} ：</span
          >{{ devInData.cameraFeatureName }}
        </div>
         <div class="item" v-show="$parent.$parent.checkDevType === '18'">
          <span class="title">IP ：</span>{{ devInData.ip }}
        </div>
        <!--<div class="item" v-show="$parent.$parent.checkDevType === '18'">
          <span class="title">端口 ：</span>{{ devInData.port }}
        </div> 
        <div class="item" v-show="$parent.$parent.checkDevType === '18'">
          <span class="title">用户名 ：</span>{{ devInData.userName }}
        </div> -->

        <div class="col" v-show="$parent.$parent.checkDevType === '18'">
          <span class="title">实况流地址 ：</span
          >{{ devInData.userName }}
        </div>
        <!-- <div class="item" v-show="$parent.$parent.checkDevType === '22'">
          <span class="title">通行方式 ：</span
          >{{
            !devInData.trafficType
              ? ""
              : devInData.trafficType == 0
              ? "出"
              : "进"
          }}
        </div> -->
        <div class="col">
          <span class="title">{{ $t("cameraList.label.deviceDec") }} ：</span>
          <div>
            {{ devInData.deviceDescription }}
          </div>
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>
<script>
export default {
  data() {
    return {
      devInData: {},
      deviceId: "",
      tabList: [],
    };
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="scss">
.tabList {
  padding: 16px;
  height: 100%;
  width: 100%;
  .tabList-container {
    display: flex;
    flex-wrap: wrap;
    height: 100%;
    width: 100%;

    .item {
      width: 50%;
      padding: 15px;
      .title {
        // color: #dddddd;
        padding-right: 10px;
      }
    }
    .col {
      width: 100%;
      padding: 15px;
      display: flex;
      line-height: 22px;
      .title {
        padding-right: 10px;
        // width: 100px;
      }
    }
  }
}
</style>
